<dx-pie-chart
    class="pie-chart"
    type="doughnut"
    palette="Harmony Light"
    [dataSource]="employeeChartData"
    [customizePoint]="customizeEmployeeChartPoint"
    [legend]="{ visible: false }"
    (onPointClick)="onEmployeePointClick()"
    [legend]="{
        visible: true,
        verticalAlignment: 'bottom',
        horizontalAlignment: 'center',
        customizeText: customizeEmployeeChartText
    }"
>
    <dxi-series argumentField="label" valueField="value">
    </dxi-series>
</dx-pie-chart>